import { render } from "./CateforySelectReduce.vue?vue&type=template&id=6ed2f6a1&ts=true"
import script from "./CateforySelectReduce.vue?vue&type=script&lang=ts"
export * from "./CateforySelectReduce.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__